module.exports = __webpack_public_path__ + "static/media/icon_finance.924acc21.svg";